<div class="grid-container mat-elevation-z10">
    <div class="" fxLayout="row" fxLayoutAlign="space-between" style="padding: 10px 30px 30px">
      <h3>Report Pause {{ data.mezzo }}</h3>
    </div>
    <div class="" style="overflow-x: auto">
      <!--(matSortChange)="onTableClicked(data)" (matSortChange)="sortData($event)" row.delivery_category_item.type.tipologia {{getCellValue(row, column) }}-->
      <table mat-table [dataSource]="data.pause"  aria-describedby="conferrals tables">
        <ng-container matColumnDef="inizio_pausa">
            <th mat-header-cell *matHeaderCellDef>
              {{ "custom-report2.grid.column.inizio_pausa" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.inizio_pausa | date:'dd/MM/yyyy, HH:mm:ss'  }}
            </td>
        </ng-container>
        <ng-container matColumnDef="fine_pausa">
            <th mat-header-cell *matHeaderCellDef>
              {{ "custom-report2.grid.column.fine_pausa"  | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.fine_pausa | date:'dd/MM/yyyy, HH:mm:ss'  }}
            </td>
        </ng-container>
        <ng-container matColumnDef="minuti_pausa">
          <th mat-header-cell *matHeaderCellDef>
            {{ "custom-report2.grid.column.minuti_pausa"  | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.minuti_pausa }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  
        <tr class="mat-row w-100" *matNoDataRow>
          <td [attr.colspan]="displayedColumns.length" class="mat-cell mat-cell-no-data text-center">
          </td>
        </tr>
      </table>
    </div>
</div>
